import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id/cloud-storage/databases/")({
  staticData: {
    title: "fleets.cloudStorage.databases",
  },
});
